// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sort-dropdown .select-dropdown[data-v-27215382]{padding:7.5px 0;box-sizing:border-box}.sort-dropdown .select-dropdown>*[data-v-27215382]{padding:7.5px 15px;box-sizing:border-box;font-size:14px;line-height:17px;color:#373f50}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
